import React, { useEffect, useState } from "react";
import { FaExclamationTriangle } from "react-icons/fa";
import { getAllAdminEmails } from "../../../api/users";
import toast from "react-hot-toast";

interface MigrateAllOffersModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: (newEmail: string) => Promise<void>;
    email?: string;
}

export default function MigrateAllOffersModal({
    isOpen,
    onClose,
    onConfirm,
    email,
}: MigrateAllOffersModalProps) {
    const [selectedUser, setSelectedUser] = useState<string>("")
    const [users, setUsers] = useState<string[]>([])
    useEffect(() => {
        const fetchAdminEmails = async () => {
            try {
                const result = await getAllAdminEmails();
                setUsers(result);
            } catch (error: any) {
                toast.error(error?.message || "Failed to fetch admin emails");
            }
        }
        fetchAdminEmails();
    }, [])
    useEffect(() => {
        if (isOpen) {
            setSelectedUser("");
        }
    }, [isOpen]);
    if (!isOpen) return null;
    return (
        <div className="fixed inset-0 flex items-center justify-center z-50">
            <div
                className="absolute inset-0 bg-black bg-opacity-50"
                onClick={onClose}
            />

            <div className="relative bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 rounded-lg p-6 w-full max-w-md shadow-lg">
                <div className="flex items-center gap-3 mb-4">
                    <h2 className="text-xl font-semibold">Migrating all Offers</h2>
                </div>

                <select
                    value={selectedUser}
                    onChange={(e) => setSelectedUser(e.target.value)}
                    className="w-full mb-6 p-2 border rounded dark:bg-gray-700 dark:border-gray-600"
                >
                    <option value="">Select user</option>
                    {users.map((u) => (
                        <option key={u} value={u}>
                            {u}
                        </option>
                    ))}
                </select>
                <p className="mb-6 text-gray-600 dark:text-gray-300">
                    Are you sure you want to migrate all offers for{" "}
                    <span className="font-medium">{email ?? "this user"}</span>?
                </p>

                <div className="flex justify-end gap-3">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 rounded-lg bg-gray-300 dark:bg-gray-700 hover:bg-gray-400 dark:hover:bg-gray-600 transition-colors"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={() => onConfirm(selectedUser)}
                        disabled={!selectedUser}
                        className="px-4 py-2 rounded-lg bg-red-500 text-white hover:bg-red-600 transition-colors disabled:opacity-50"
                    >
                        Migrate
                    </button>
                </div>
            </div>
        </div>

    );
}
